import { createContext, useContext, useState, useCallback, type ReactNode } from 'react';
import type { WalletState } from '@/types/tokenized.types';

const MOCK_ADDRESS = '0x742d35Cc6634C0532925a3b844Bc9e7595f2bD18';

interface WalletContextType {
  wallet: WalletState;
  connect: () => void;
  disconnect: () => void;
  shortenAddress: (addr: string) => string;
}

const WalletContext = createContext<WalletContextType | undefined>(undefined);

export function WalletProvider({ children }: { children: ReactNode }) {
  const [wallet, setWallet] = useState<WalletState>({
    connected: false,
    address: null,
    chainId: null,
    balance: 0,
    usdcBalance: 0,
  });

  const connect = useCallback(() => {
    setWallet({
      connected: true,
      address: MOCK_ADDRESS,
      chainId: 84532,
      balance: 1.247,
      usdcBalance: 25_000,
    });
  }, []);

  const disconnect = useCallback(() => {
    setWallet({
      connected: false,
      address: null,
      chainId: null,
      balance: 0,
      usdcBalance: 0,
    });
  }, []);

  const shortenAddress = useCallback((addr: string) => {
    return `${addr.slice(0, 6)}...${addr.slice(-4)}`;
  }, []);

  return (
    <WalletContext.Provider value={{ wallet, connect, disconnect, shortenAddress }}>
      {children}
    </WalletContext.Provider>
  );
}

export function useWalletMock(): WalletContextType {
  const ctx = useContext(WalletContext);
  if (!ctx) {
    throw new Error('useWalletMock must be used within a WalletProvider');
  }
  return ctx;
}
